var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.457 15.7102L6.9375 18.0469C6.62578 18.1781 6.31172 18.0867 6.1125 17.8852C5.91328 17.6836 5.82188 17.3719 5.95312 17.0625L8.29219 11.5453C8.32969 11.4563 8.38359 11.3742 8.45156 11.3063L17.7609 1.99688C18.4195 1.33828 19.493 1.33359 20.1516 1.99219L22.0102 3.85078C22.6687 4.50938 22.6641 5.58281 22.0055 6.24141L12.6961 15.5508C12.6258 15.6187 12.5461 15.6727 12.457 15.7102ZM2.34375 20.8125H21.6562C22.1227 20.8125 22.5 21.1898 22.5 21.6562C22.5 22.1227 22.1227 22.5 21.6562 22.5H2.34375C1.87734 22.5 1.5 22.1227 1.5 21.6562C1.5 21.1898 1.87734 20.8125 2.34375 20.8125ZM18.9539 3.18984L18.9586 3.18516L20.8148 5.04141L20.8102 5.04609L19.357 6.49922L17.5008 4.64297L18.9539 3.18984ZM16.3078 5.83594L9.77344 12.3703L8.40938 15.5906L11.6297 14.2266L18.1641 7.69219L16.3078 5.83594Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.a420d2edb5e92e2d143a2081df51bd5f.svg";
export { ForwardRef as ReactComponent };